<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋名稱" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </template>
    <template slot="right">
      <el-button @click="onCreate" style="margin-right: 20px;">新增標籤</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="名稱" min-width="120px">
          <template slot-scope="scope">
            {{scope.row.Name}}
          </template>
        </el-table-column>
        <el-table-column label="權重" width="50px">
          <template slot-scope="scope">
            <p style="text-align: right;">{{scope.row.Weigh}}</p>
          </template>
        </el-table-column>
        <el-table-column label="置頂" width="50px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsTop" class="deployed" style="text-align: center;">✓</p>
            <p v-else class="draft"></p>
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="onUpdate(scope.row)">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <post-tag-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/components/LeftMenu.vue'
import TopHeader from '@/components/TopHeader.vue'
import PostTagEditorModal from '@/modals/PostTagEditorModal.vue'
// svgs
import '@/assets/svgs/index.js'

export default {
  components: {
    LeftMenu,
    TopHeader,
    PostTagEditorModal
  },
  data () {
    return {
      searchedObjs: [],
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      searchTimer: null,
      keyword: '',
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {},
  methods: {
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    delaySearch () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = window.setTimeout(() => {
        this.searchTimer = null
        this.search()
      }, 500)
    },
    search () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
      this.currentPage = 1
      this.alertSearchResult()
    },
    searchWithoutAlertResult () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
      this.currentPage = 1
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.post.tagList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isNameFit = o.Name && o.Name.includes(this.keyword)
        return isNameFit
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.post.tagList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    alertSearchResult () {
      if (this.searchedObjs.length > 0) {
        this.$message({
          message: `搜尋結果共${this.searchedObjs.length}筆符合條件`,
          duration: 1000
        })
      } else {
        this.$message({
          message: '查無符合條件',
          duration: 1000
        })
      }
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 ${obj.Name} ?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.postTag.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.post.tagList.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.post.tagList.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      })
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.post.tagList
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    if (
      !this.$store.state.post.isFetched &&
      !this.$store.state.post.isFetching
    ) {
      this.$services.fetchPostDatas(this).then(initTableData)
    } else {
      initTableData()
    }
  },
  filters: {
    moment (str) {
      return moment(str).format('LLL')
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
